export default __webpack_public_path__ + "8174f676441c58e7722c03ea89f58945.svg";